class ReportsController {
  constructor(ReportsFactory, MatchesFactory, $rootScope, $filter) {
    "ngInject";

    const vm = this;

    vm.rootScope = $rootScope;
    let $date = $filter("date");
    vm.dateConfig = {
      startView: "month",
      minView: "month",
      dropdownSelector: "#dateDropdown",
    };

    vm.$onInit = () => {
      vm.years = [2023, 2024, "ALL"];
      vm.currentYear = null;
      vm.currentReport = null;
      vm.matches = [];
      vm.selectedMatches = [];
      vm.showMatches = false;
      vm.showSelectDay = false;
      vm.showAgeFilter = false;
      vm.ageFilterTo = null;
      vm.ageFilterFrom = null;
      vm.selectedDay = new Date();
    };

    vm.reports = [
      {
        id: ReportsFactory.STATISTIC_REPORTS.PLAYER_REGISTER,
        name: "REPORT_1",
        hasOptions: true,
        showAgeFilter: true,
      },
      { id: ReportsFactory.STATISTIC_REPORTS.TEAM_REGISTER, name: "REPORT_2" },
      {
        id: ReportsFactory.STATISTIC_REPORTS.REGISTERED_REGISTER,
        name: "REPORT_3",
      },
      {
        id: ReportsFactory.STATISTIC_REPORTS.MATCHES_WITH_ENTRIES,
        name: "REPORT_4",
      },
      {
        id: ReportsFactory.STATISTIC_REPORTS.LEAGUES_ENTRIES,
        name: "REPORT_5",
      },
      { id: ReportsFactory.STATISTIC_REPORTS.TEAM_PLAYERS, name: "REPORT_6" },
      {
        id: ReportsFactory.STATISTIC_REPORTS.PLAYER_LEAGUE,
        name: "REPORT_7",
        hasOptions: true,
        selectMatch: true,
      },
      // {
      //   id: ReportsFactory.STATISTIC_REPORTS.MULTIWIN,
      //   name: "REPORT_8",
      //   hasOptions: true,
      //   selectMatch: true,
      // },
      {
        id: ReportsFactory.STATISTIC_REPORTS.TRAINING_ENTRIES,
        name: "REPORT_9",
        hasOptions: true,
        selectDate: true,
      },
      {
        id: ReportsFactory.STATISTIC_REPORTS.PLAYER_LEAGUE_UNIQUE,
        name: "REPORT_10",
        hasOptions: true,
        selectMatch: true,
      },
      // {id: ReportsFactory.STATISTIC_REPORTS.GGA_PLAYERS, name: 'REPORT_11'},
      // {id: ReportsFactory.STATISTIC_REPORTS.GGA_TEAMS, name: 'REPORT_12'},
      {
        id: ReportsFactory.STATISTIC_REPORTS.MEDALS,
        name: "REPORT_13",
        hasOptions: true,
        selectMatch: true,
      },
    ];

    vm.selectYear = (year) => {
      vm.currentYear = year;
      let params = { year: year };
      MatchesFactory.getAll(params).then((response) => {
        vm.matches = response.data;
      });
    };

    vm.getReport = (report) => {
      if (report.hasOptions) {
        vm.currentReport = report;
        vm.showMatches = report.selectMatch;
        vm.showSelectDay = report.selectDate;
        vm.showAgeFilter = report.showAgeFilter;
        return;
      }
      vm.currentReport = null;
      vm.showMatches = false;
      vm.showSelectDay = false;
      vm.getPDF(report, null);
    };

    vm.getReportWithOptions = () => {
      let matchesString = "";
      Object.entries(vm.selectedMatches).forEach(([key, value]) => {
        if (matchesString === "") {
          matchesString = matchesString + value;
        } else {
          matchesString = matchesString + "," + value;
        }
      });
      vm.selectedDay = $date(vm.selectedDay, "yyyy-MM-dd");
      let data = {
        matches: matchesString,
        selectedDay: vm.selectedDay,
        ageFilterFrom: vm.ageFilterFrom,
        ageFilterTo: vm.ageFilterTo,
      };
      vm.getPDF(vm.currentReport, data);
    };

    vm.getPDF = (report, data) => {
      const tabWindowId = window.open("about:blank", "_blank");
      tabWindowId.document.write("<h1>Loading...</h1>");
      ReportsFactory.statistics(report.id, vm.currentYear, data)
        .then((response) => {
          let file = new Blob([response.data], { type: "application/pdf" });
          tabWindowId.location.href = window.URL.createObjectURL(file);
        })
        .catch((e) =>
          tabWindowId.document.write("<h1>Παρουσιάστηκε κάποιο πρόβλημα.</h1>")
        );
    };
  }
}

export default ReportsController;



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.controller.js